import { Controller } from '@hotwired/stimulus'

export default class NewUboFormController extends Controller {
  static targets = [
    'addUboButton',
    'addUboSimpleButton',
    'ubo',
    'hasMultipleUbos',
    'prefilledTemplate',
    'soleUboExplanation',
    'noUboMessage',
    'buttonsContainer',
  ];

  connect() {
    this.toggleUboForm(null);
    this.scrollToFirstError();
  }

  toggleUboForm(event) {
    if (this.hasMultipleUbosTarget.checked) {
      this.handleUboCountChange(null);
      if (this.hasSoleUboExplanationTarget) {
        this.soleUboExplanationTarget.classList.add('d-none');
      }
    } else if (!this.hasMultipleUbosTarget.checked) {
      this.addUboButtonTarget.classList.add('d-none');
      this.addUboSimpleButtonTarget.classList.add('d-none');
      if (this.hasSoleUboExplanationTarget) {
        this.soleUboExplanationTarget.classList.remove('d-none');
      }
    }

    this.toggleNoUboMessage();
    this.toggleButtonsContainer();
  }

  toggleNoUboMessage() {
    if (this.uboTargets.filter((elem) => !elem.dataset.destroyed).length === 0) {
      this.noUboMessageTarget.classList.remove('d-none');
    } else {
      this.noUboMessageTarget.classList.add('d-none');
    }
  }

  toggleButtonsContainer() {
    if (this.hasMultipleUbosTarget.checked && this.uboTargets.filter((elem) => !elem.dataset.destroyed).length === 0) {
      this.buttonsContainerTarget.classList.add('d-none');
    } else {
      this.buttonsContainerTarget.classList.remove('d-none');
    }
  }

  resetForm(event) {
    this.toggleUboForm(event);

    const nestedFormController = this.application.getControllerForElementAndIdentifier(this.element, 'nested-form');

    if (this.hasMultipleUbosTarget.checked) {
      nestedFormController.reset();
    } else {
      nestedFormController.reset();
      nestedFormController.add(this.prefilledTemplateTarget);
    }

    this.toggleButtonsContainer();
  }

  handleUboCountChange(event) {
    if (!this.hasMultipleUbosTarget.checked) { return; }

    this.addUboButtonTarget.classList.add('d-none');
    this.addUboSimpleButtonTarget.classList.add('d-none');

    const numOfUbo = this.uboTargets.filter((elem) => !elem.dataset.destroyed).length;
    if (numOfUbo == 0) {
      this.addUboButtonTarget.classList.remove('d-none');
      this.addUboSimpleButtonTarget.classList.add('d-none');
    } else if (numOfUbo < 10) {
      this.addUboSimpleButtonTarget.classList.remove('d-none');
    }

    this.toggleNoUboMessage();
  }

  scrollToFirstError() {
    const firstError = this.element.querySelector('.is-invalid, .invalid-feedback');

    if (firstError) {
      firstError.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  }

  uboTargetConnected(event) {
    this.toggleUboForm(event);
  }
}
